import { wordpressClient } from '../config/axiosConfig'
import { mapStringToTitle, Title } from '../components/wrestler/Title'
import { create } from 'zustand'

interface MatchcardState {
  announcements: MatchcardData[]
  getMatchcardForEvent: (eventId: number) => MatchcardData[]
  loaded: boolean
}

export interface MatchcardData {
  id: number
  isWrestler: boolean
  wrestlerName: string
  bildAnkuendigung: string
  stipulation: string
  teilnehmer: string
  title: Title[]
  eventIds: number[]
}

interface MatchcardResponse {
  id: number
  acf: {
    art_der_ankundigung: string
    bild_ankuendigung: string
    stipulation: string
    teilnehmer: string
    titel: string[]
    name_des_wrestlers: string
    event: number[]
  }
}

export const useMatchcardStore = create<MatchcardState>()(() => ({
  announcements: [],
  getMatchcardForEvent: (eventId: number): MatchcardData[] => {
    return useMatchcardStore
      .getState()
      .announcements.filter((announcement) => announcement.eventIds.includes(eventId))
  },
  loaded: false,
}))

wordpressClient
  .get<MatchcardResponse[]>('ankuendigung', {
    params: {
      // prettier-ignore
      'per_page': 100,
    },
  })
  .then((response) => {
    if (response.status === 200) {
      const announcements: MatchcardData[] = response.data.map((announcement) => ({
        id: announcement.id,
        isWrestler: announcement.acf.art_der_ankundigung === 'Wrestler Ankündigung',
        wrestlerName: announcement.acf.name_des_wrestlers,
        bildAnkuendigung: announcement.acf.bild_ankuendigung,
        stipulation: announcement.acf.stipulation,
        teilnehmer: announcement.acf.teilnehmer,
        title: announcement.acf.titel.map((title): Title => {
          return mapStringToTitle(title)
        }),
        eventIds: announcement.acf.event,
      }))
      useMatchcardStore.setState({ announcements: announcements, loaded: true })
    }
  })
  .catch((error) => {
    console.error('Error fetching announcements:', error)
  })
